module.exports = __webpack_public_path__ + "img/1440.eba9c8f0.jpg";